import { useMemo } from 'react';

import { useFeatureFlag_Core } from 'core';
import { EventTicket } from 'core/Components';
import { useParams, useSearchParams } from 'react-router-dom';
import { useShowRedeemableTicketFromPurchasedCart } from 'store/Api';
import { Center, LoadingOverlay, Stack, Text, Title } from 'ui';

import classes from './TicketsPage.module.css';
import { TicketsPageLayout } from './TicketsPageLayout/TicketsPageLayout';
import { makeTicketInfo } from './utils';

const TicketPage = () => {
  const routeParams = useParams();
  const [searchParams] = useSearchParams();
  const { isFeatureEnabled: isAccountPageEnabled } = useFeatureFlag_Core({
    featureId: 'user.account_page',
  });

  const cartId = searchParams.get('cart_id') ?? undefined;
  const ticketId = routeParams.ticketId;

  const { data, isLoading } = useShowRedeemableTicketFromPurchasedCart({
    cartId,
    ticketId,
  });

  const ticketInfo = useMemo(
    () => makeTicketInfo(data, isAccountPageEnabled),
    [data, isAccountPageEnabled]
  );

  if (isLoading) return <LoadingOverlay visible={isLoading} />;

  if (!ticketInfo) {
    return (
      <Center px="lg">
        <Stack gap="xs" align="center">
          <Title order={3}>No ticket found</Title>
          <Text type="sub">Please check your order details and try again.</Text>
        </Stack>
      </Center>
    );
  }

  return (
    <TicketsPageLayout
      title={<Title order={2}>{ticketInfo?.eventTitle}</Title>}
      right={
        <EventTicket
          className={classes.TicketsPage__ticket}
          eventThumbnail={ticketInfo.eventThumbnail}
          title={ticketInfo.eventTitle}
          subtitle={ticketInfo.eventDateTitle}
          eventStartDate={ticketInfo.eventStartDate}
          venueName={ticketInfo.venueName}
          addressLineOne={ticketInfo.addressLineOne}
          addressLineTwo={ticketInfo.addressLineTwo}
          city={ticketInfo.city}
          state={ticketInfo.state}
          zipCode={ticketInfo.zipCode}
          ticketUrl={ticketInfo.ticketUrl}
          ticketId={ticketInfo.ticketId}
          ticketName={ticketInfo.ticketName}
          isExpired={ticketInfo.isExpired}
          isUsed={ticketInfo.isUsed}
          ticketQrCodeUrl={ticketInfo.ticketQrCodeUrl}
        />
      }
    />
  );
};

export { TicketPage };
